import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { UIButtonVariant, UIBoxDecoration, UISize } from '../types';

export interface IBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: UIButtonVariant;
  decoration?: UIBoxDecoration;
  padded?: boolean;

  /**
   * Size the button on a fixed scale
   */
  size?: UISize;

  /**
   * use circular shape (this will apply border-radius: 50% with a fixed width and height)
   */
  circle?: boolean;

  /**
   * use rounded corners (default)
   */
  rounded?: boolean;

  /**
   * use pill shaped corners
   */
  pill?: boolean;

  /**
   * use squared corners
   */
  squared?: boolean;

  block?: boolean;
}

export default function Badge({
  children,
  className,
  decoration,
  variant = 'primary',
  padded,
  block,
  pill,
  circle,
  squared,
  rounded,
  size = 'base',
  ...otherProps
}: IBadgeProps): React.ReactElement {
  const bem = bemBlock('badge');
  const blockClasses = bem(
    null,
    [
      { [variant]: variant },
      { padded },
      { block },
      { [`size-${size}`]: size },
      { pill },
      { circle },
      { squared },
      { rounded },
      { [`decoration-${decoration}`]: decoration },
    ],
    className
  );

  return (
    <div className={blockClasses} {...otherProps}>
      {children}
    </div>
  );
}
